import React from 'react';
import ChartDatasetSettings from '../../settings_sidebar/ChartDatasetSettings.jsx';
import { DEFAULT_DATASET_SETTINGS } from '../../settings_sidebar/dataset/DatasetSettingsRow.jsx';
import { DEFAULT_ADDITIONAL_SETTINGS } from '../../settings_sidebar/chart/ChartSettings.jsx';

function ValuesAchievedDatasetWidgetSettings({ widgetId }) {
    return (
        <ChartDatasetSettings
            chart_settings_props={{
                additional_settings: [...DEFAULT_ADDITIONAL_SETTINGS, "number_format", "show_total_value"]
            }}
            dataset_settings_props={{
                dataset_settings: [...DEFAULT_DATASET_SETTINGS, 'main_value_ds']
            }}
            widgetId={widgetId}
        />
    )
}

export default ValuesAchievedDatasetWidgetSettings;
